import { createAction, props } from '@ngrx/store';
import { Offering } from '@shared/models/offering';

export const loadOfferings = createAction('[Offerings] Load Offerings');

export const loadOfferingsSuccess = createAction('[Offerings] Load Offerings Success', props<{ data: Offering[] }>());

export const loadOfferingsFailure = createAction('[Offerings] Load Offerings Failure', props<{ error: any }>());
